function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var CryptoModule = require('../../lib/templates/cryptomodule');
var _require = require('@multiversx/sdk-core'),
  ApiNetworkProvider = _require.ApiNetworkProvider,
  ProxyNetworkProvider = _require.ProxyNetworkProvider,
  Account = _require.Account,
  UserSigner = _require.UserSigner,
  Address = _require.Address,
  UserWallet = _require.UserWallet,
  Transaction = _require.Transaction,
  TransactionComputer = _require.TransactionComputer,
  UserSecretKey = _require.UserSecretKey,
  Mnemonic = _require.Mnemonic;
var PeerService = require('saito-js/lib/peer_service')["default"];
var EGLDModule = /*#__PURE__*/function (_CryptoModule) {
  function EGLDModule(app) {
    var _this;
    _classCallCheck(this, EGLDModule);
    _this = _callSuper(this, EGLDModule, [app, 'EGLD']);

    // For interacting with the network api
    _this.apiNetworkProvider = null;
    _this.proxyNetworkProvider = null;
    _this.networkConfig = null;
    _this.slug = 'egld';
    _this.status = 'prod';
    _this["class"] = 'utility';
    _this.account = null;
    _this.address_obj = null;
    _this.secretKey = null;

    /* Should default to testnet if no ENV variables...
    this.base_url = "https://testnet-api.multiversx.com";
    this.network_provider_url = "https://testnet-gateway.multiversx.com";
    this.explorer_url = "https://testnet-explorer.multiversx.com";
    */
    return _this;
  }
  _inherits(EGLDModule, _CryptoModule);
  return _createClass(EGLDModule, [{
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app) {
        var _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return _superPropGet(EGLDModule, "initialize", this, 3)([app]);
            case 1:
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.error('Error initialize:', _t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function initialize(_x) {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "activate",
    value: function () {
      var _activate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              if (!this.isActivated()) {
                this.app.connection.emit('saito-header-install-crypto', this.ticker);
              }
              _context2.n = 1;
              return this.setupNetwork();
            case 1:
              _context2.n = 2;
              return this.getAddress();
            case 2:
              _context2.n = 3;
              return this.updateAccount();
            case 3:
              _context2.n = 4;
              return _superPropGet(EGLDModule, "activate", this, 3)([]);
            case 4:
              _context2.n = 6;
              break;
            case 5:
              _context2.p = 5;
              _t2 = _context2.v;
              console.error('Error activate:', _t2);
            case 6:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 5]]);
      }));
      function activate() {
        return _activate.apply(this, arguments);
      }
      return activate;
    }()
  }, {
    key: "getAddress",
    value: function () {
      var _getAddress = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this$options, mnemonic, mnemonic_text, save_me, publicKey, _t3, _t4, _t5;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              mnemonic = null;
              _t3 = (_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.mnemonic_text;
              if (_t3) {
                _context3.n = 2;
                break;
              }
              _t4 = this.app.crypto;
              _context3.n = 1;
              return this.app.wallet.getPrivateKey();
            case 1:
              _t3 = _t4.generateSeedFromPrivateKey.call(_t4, _context3.v);
            case 2:
              mnemonic_text = _t3;
              save_me = false;
              if (mnemonic_text) {
                mnemonic = Mnemonic.fromString(mnemonic_text);
              } else {
                // Generate Ed25519 key pair
                mnemonic = Mnemonic.generate();
                save_me = true;
              }
              this.secretKey = mnemonic.deriveKey(0);
              publicKey = this.secretKey.generatePublicKey();
              this.address_obj = publicKey.toAddress();
              if (save_me) {
                this.options.mnemonic_text = mnemonic.text;
              }
              this.options.address = this.address = this.address_obj.toBech32();
              _context3.n = 4;
              break;
            case 3:
              _context3.p = 3;
              _t5 = _context3.v;
              console.error('Error creating EGLD address:', _t5);
            case 4:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 3]]);
      }));
      function getAddress() {
        return _getAddress.apply(this, arguments);
      }
      return getAddress;
    }()
  }, {
    key: "updateAccount",
    value: function () {
      var _updateAccount = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var accOnNetwork, _t6;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              if (!(this.apiNetworkProvider == null)) {
                _context4.n = 1;
                break;
              }
              console.warn('No API Network Provided...');
              return _context4.a(2);
            case 1:
              if (!(this.address_obj != null)) {
                _context4.n = 3;
                break;
              }
              if (this.account == null) {
                this.account = new Account(this.address_obj);
              }
              // console.log("updateAccount this.address_obj:", this.address_obj);
              _context4.n = 2;
              return this.apiNetworkProvider.getAccount(this.address_obj);
            case 2:
              accOnNetwork = _context4.v;
              this.account.update(accOnNetwork);
              this.options.bigIntBalance = BigInt(this.account.balance.toNumber());
              this.options.balance = this.balance = this.convertAtomicToEgld(this.options.bigIntBalance);
              this.options.nonce = this.account.nonce;

            // console.log("updateAccount account: ", this.account);
            // console.log("updateAccount account balance bigint: ", this.balance);
            //console.log("updateAccount account balance: ", this.account.balance.toString());
            case 3:
              _context4.n = 5;
              break;
            case 4:
              _context4.p = 4;
              _t6 = _context4.v;
              console.error('Error updating EGLD account:', _t6);
            case 5:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 4]]);
      }));
      function updateAccount() {
        return _updateAccount.apply(this, arguments);
      }
      return updateAccount;
    }()
  }, {
    key: "fetchBalance",
    value: function () {
      var _fetchBalance = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              return _context5.a(2, this.updateAccount());
          }
        }, _callee5, this);
      }));
      function fetchBalance() {
        return _fetchBalance.apply(this, arguments);
      }
      return fetchBalance;
    }()
  }, {
    key: "formatReadableNum",
    value: function formatReadableNum(num) {
      try {
        if (num % 1 === 0) {
          return num.toString(); // Return as is for integers
        }
        var numStr = num.toString();
        var decimalIndex = numStr.indexOf('.');
        if (decimalIndex !== -1) {
          var trailingZerosTrimmed = numStr.replace(/(\.\d*?)0+$/, '$1'); // Remove trailing zeros
          return trailingZerosTrimmed;
        }
        return numStr; // Return unchanged if no decimal part exists
      } catch (error) {
        console.error('Error formatReadableNum:', error);
      }
    }
  }, {
    key: "getNonce",
    value: function () {
      var _getNonce = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var _t7;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _context6.p = 0;
              _context6.n = 1;
              return this.updateAccount();
            case 1:
              return _context6.a(2, this.options.nonce);
            case 2:
              _context6.p = 2;
              _t7 = _context6.v;
              console.error('Error getNonce:', _t7);
            case 3:
              return _context6.a(2);
          }
        }, _callee6, this, [[0, 2]]);
      }));
      function getNonce() {
        return _getNonce.apply(this, arguments);
      }
      return getNonce;
    }()
    /**
     * epoch: 1846
     * fee: "50000000000000"
     * function: "transfer"
     * gasLimit: 50000
     * gasPrice: 1000000000
     * gasUsed: 50000
     * miniBlockHash: "2ed16b9169ee4ebeecc574dbff7dd2fd1ebf2d5cbb52249b13adf29d03c506cd"
     * nonce: 34
     * receiver: "erd12fqc02q7rs7gnwwkdzqau38j4zgz4wnq2der5z88rxez26ccvlqqr95vls"
     * receiverShard: 0
     * round: 26589487
     * sender: "erd1u7pqwrpe9840gaaepll4prvm97y0f7rga29kvn4ndte83hsj43qq6d3c24"
     * senderShard: 0
     * signature: "e3bb58305a351448b64ce22087609eb3e876bdfa5ffca6c3af5732fc2870badb5aa89bc074fd44e3211fdc8bb818fcc2ae8e2e56185e73c158b683d6bdbba801"
     * status: "success"
     * timestamp: 1755654522
     * txHash: "eb90cf107c2952abe10dfa7ceab8bfcdb05087197a60a8fd83e0e17d03e0f192"
     * value: "750000000000000000"
     *
     */
  }, {
    key: "fetchHistory",
    value: function () {
      var _fetchHistory = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var ts,
          callback,
          address,
          transactions,
          keys,
          timestamp,
          _iterator,
          _step,
          t,
          amount,
          fee,
          obj,
          _iterator2,
          _step2,
          k,
          _args7 = arguments,
          _t8,
          _t9,
          _t0;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              ts = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : null;
              callback = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : null;
              _context7.p = 1;
              address = Address.newFromBech32(this.address);
              _context7.n = 2;
              return this.apiNetworkProvider.doGetGeneric("accounts/".concat(address.toBech32(), "/transactions"));
            case 2:
              transactions = _context7.v;
              keys = this.app.keychain.returnKeys();
              console.log('return history: ', transactions);
              timestamp = 0;
              if (!(transactions.length > 0)) {
                _context7.n = 18;
                break;
              }
              // Make sure in ascending order
              transactions.sort(function (a, b) {
                return a.timestamp - b.timestamp;
              });
              _iterator = _createForOfIteratorHelper(transactions);
              _context7.p = 3;
              _iterator.s();
            case 4:
              if ((_step = _iterator.n()).done) {
                _context7.n = 14;
                break;
              }
              t = _step.value;
              timestamp = t.timestamp * 1000;
              if (!(timestamp < this.history_update_ts)) {
                _context7.n = 5;
                break;
              }
              return _context7.a(3, 13);
            case 5:
              amount = this.convertAtomicToEgld(BigInt(t.value));
              fee = this.convertAtomicToEgld(BigInt(t.fee));
              obj = {
                counter_party: {},
                timestamp: timestamp,
                amount: Number(amount),
                fee: Number(fee),
                trans_hash: t.txHash
              };
              if (t.sender === this.address) {
                // I am the sender
                obj.counter_party.address = t.receiver;
                obj.type = 'send';
                obj.amount = -obj.amount;
              } else {
                // I am the receiver
                obj.counter_party.address = t.sender;
                obj.type = 'receive';
              }
              if (t.status !== 'success') {
                obj.status = t.status;
              }

              // look for egld address in my saito keychain
              _iterator2 = _createForOfIteratorHelper(keys);
              _context7.p = 6;
              _iterator2.s();
            case 7:
              if ((_step2 = _iterator2.n()).done) {
                _context7.n = 9;
                break;
              }
              k = _step2.value;
              if (!(k.crypto_addresses && k.crypto_addresses[this.ticker] == obj.counter_party.address)) {
                _context7.n = 8;
                break;
              }
              obj.counter_party.publicKey = k.publicKey;
              return _context7.a(3, 9);
            case 8:
              _context7.n = 7;
              break;
            case 9:
              _context7.n = 11;
              break;
            case 10:
              _context7.p = 10;
              _t8 = _context7.v;
              _iterator2.e(_t8);
            case 11:
              _context7.p = 11;
              _iterator2.f();
              return _context7.f(11);
            case 12:
              this.history.push(obj);
            case 13:
              _context7.n = 4;
              break;
            case 14:
              _context7.n = 16;
              break;
            case 15:
              _context7.p = 15;
              _t9 = _context7.v;
              _iterator.e(_t9);
            case 16:
              _context7.p = 16;
              _iterator.f();
              return _context7.f(16);
            case 17:
              this.history_update_ts = Math.max(this.history_update_ts, timestamp) + 1;
              this.save();
            case 18:
              if (!callback) {
                _context7.n = 19;
                break;
              }
              callback(transactions);
              return _context7.a(2);
            case 19:
              _context7.n = 21;
              break;
            case 20:
              _context7.p = 20;
              _t0 = _context7.v;
              console.error('Error fetchHistory:', _t0);
            case 21:
              if (callback) {
                callback([]);
              }
            case 22:
              return _context7.a(2);
          }
        }, _callee7, this, [[6, 10, 11, 12], [3, 15, 16, 17], [1, 20]]);
      }));
      function fetchHistory() {
        return _fetchHistory.apply(this, arguments);
      }
      return fetchHistory;
    }()
  }, {
    key: "sendPayment",
    value: function () {
      var _sendPayment = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var amount,
          recipient,
          unique_hash,
          chainID,
          txObj,
          transaction,
          txComputer,
          serializedTX,
          txHash,
          _args8 = arguments,
          _t1;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              amount = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : '';
              recipient = _args8.length > 1 && _args8[1] !== undefined ? _args8[1] : '';
              unique_hash = _args8.length > 2 && _args8[2] !== undefined ? _args8[2] : '';
              _context8.p = 1;
              console.log('inside sendPayment ////');
              console.log('amount, recipient, unique_hash: ', amount, recipient, unique_hash);
              console.log('this.egld: ', this.options);
              if (this.address_obj == null) {
                this.load();
              }

              // update account to get latest nonce
              this.updateAccount();

              // Determine chainID from api-urls
              chainID = '1';
              if (this.options.base_url.includes('devnet')) {
                chainID = 'D';
              }
              if (this.options.base_url.includes('testnet')) {
                chainID = 'T';
              }
              txObj = {
                value: this.convertEgldToAtomic(amount),
                sender: this.address_obj,
                receiver: Address.newFromBech32(recipient),
                chainID: chainID,
                nonce: this.options.nonce,
                gasLimit: 50000
                //data: "SAITO multiwallet transfer"
              };
              console.log('txObj: ', txObj);

              // get funds to you address before creating the transaction
              transaction = new Transaction(txObj); // let gasLimit =   this.networkConfig.erd_min_gas_limit +
              //                 this.networkConfig.erd_gas_per_data_byte * (Buffer.from(transaction.data, "hex").length);
              console.log('transaction before: ', transaction);

              // serialize transaction for signing
              txComputer = new TransactionComputer();
              serializedTX = txComputer.computeBytesForSigning(transaction);
              console.log('serializedTX: ', serializedTX);

              // set the signature
              transaction.signature = this.secretKey.sign(serializedTX);
              console.log('transaction after: ', transaction);

              // broadcast transaction
              _context8.n = 2;
              return this.apiNetworkProvider.sendTransaction(transaction);
            case 2:
              txHash = _context8.v;
              console.log('txHash: ', txHash);
              return _context8.a(2, txHash);
            case 3:
              _context8.p = 3;
              _t1 = _context8.v;
              console.error('Error sendPayment:', _t1);
            case 4:
              return _context8.a(2);
          }
        }, _callee8, this, [[1, 3]]);
      }));
      function sendPayment() {
        return _sendPayment.apply(this, arguments);
      }
      return sendPayment;
    }()
  }, {
    key: "receivePayment",
    value: function () {
      var _receivePayment = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var amount,
          sender,
          unique_hash,
          timestamp,
          this_self,
          status,
          address,
          txs,
          tx,
          senders,
          snapshot_amount,
          _args9 = arguments,
          _t10;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              amount = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : '';
              sender = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : '';
              unique_hash = _args9.length > 2 && _args9[2] !== undefined ? _args9[2] : '';
              timestamp = 0;
              this_self = this;
              status = 0;
              _context9.p = 1;
              console.log('amount, sender, timestamp, unique_hash:');
              console.log(amount, sender, timestamp, unique_hash);
              address = Address.newFromBech32(this.address);
              _context9.n = 2;
              return this.apiNetworkProvider.doGetGeneric("accounts/".concat(address.toBech32(), "/transactions"));
            case 2:
              txs = _context9.v;
              console.log('receivePayment transactions: ', txs);
              tx = txs[0]; //compare timestamps
              timestamp = Math.floor(timestamp / 1000);
              console.log('received_datetime - snapshot_datetime - diff : ', timestamp, tx.timestamp, tx.timestamp - timestamp);
              if (!(tx.timestamp - timestamp > 0)) {
                _context9.n = 3;
                break;
              }
              console.log('*************************************');
              console.log('snapshot response ///');
              senders = tx.senders;
              console.log('sender: ', sender);
              console.log('sender: ', tx.sender);
              console.log('sender == : ', sender == tx.sender);

              // filter out opponents
              if (!(tx.sender == sender)) {
                _context9.n = 3;
                break;
              }
              console.log('opponent_id matched ////');
              console.log('tx: ', tx);
              snapshot_amount = this.convertAtomicToEgld(tx.value);
              console.log('amount: ', amount);
              console.log('snapshot_amount: ', snapshot_amount);
              if (!(Number(snapshot_amount) == Number(amount))) {
                _context9.n = 3;
                break;
              }
              console.log('checking status ///');

              // check tx status
              if (!(tx.status == 'success')) {
                _context9.n = 3;
                break;
              }
              console.log('match found ///');
              return _context9.a(2, 1);
            case 3:
              console.log('receivePayment status: ', status);
              return _context9.a(2, status);
            case 4:
              _context9.p = 4;
              _t10 = _context9.v;
              console.error('Error fetching transaction status:', _t10.message);
              return _context9.a(2, status);
          }
        }, _callee9, this, [[1, 4]]);
      }));
      function receivePayment() {
        return _receivePayment.apply(this, arguments);
      }
      return receivePayment;
    }()
  }, {
    key: "getTransactionStatus",
    value: function () {
      var _getTransactionStatus = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(txHash) {
        var transactionDetails, _t11;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.p = _context0.n) {
            case 0:
              _context0.p = 0;
              _context0.n = 1;
              return this.apiNetworkProvider.getTransaction(txHash);
            case 1:
              transactionDetails = _context0.v;
              return _context0.a(2, transactionDetails);
            case 2:
              _context0.p = 2;
              _t11 = _context0.v;
              console.error('Error fetching transaction status:', _t11.message);
            case 3:
              return _context0.a(2);
          }
        }, _callee0, this, [[0, 2]]);
      }));
      function getTransactionStatus(_x2) {
        return _getTransactionStatus.apply(this, arguments);
      }
      return getTransactionStatus;
    }()
  }, {
    key: "checkWithdrawalFeeForAddress",
    value: function () {
      var _checkWithdrawalFeeForAddress = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(address, callback) {
        var fee, _t12;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.p = _context1.n) {
            case 0:
              _context1.p = 0;
              fee = BigInt(this.networkConfig.MinGasLimit * this.networkConfig.MinGasPrice);
              console.log('egld fee;', fee);
              return _context1.a(2, callback(this.convertAtomicToEgld(fee)));
            case 1:
              _context1.p = 1;
              _t12 = _context1.v;
              console.error('Error checkWithdrawalFeeForAddress:', _t12);
            case 2:
              return _context1.a(2);
          }
        }, _callee1, this, [[0, 1]]);
      }));
      function checkWithdrawalFeeForAddress(_x3, _x4) {
        return _checkWithdrawalFeeForAddress.apply(this, arguments);
      }
      return checkWithdrawalFeeForAddress;
    }()
  }, {
    key: "convertEgldToAtomic",
    value: function convertEgldToAtomic() {
      var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '0.0';
      try {
        var bigIntNum = 0;
        var num = Number(amount);
        if (num > 0) {
          bigIntNum = num * 1000000000000000000; // 100,000,000
        }
        return bigIntNum;
      } catch (error) {
        console.error('Error convertEgldToAtomic:', error);
      }
    }
  }, {
    key: "convertAtomicToEgld",
    value: function convertAtomicToEgld() {
      var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : BigInt(0);
      try {
        var string = '0.00';
        var num = 0;
        var bigint_divider = 1000000000000000000n;
        num = Number(BigInt(amount) * 1000000000000000000n / bigint_divider) / 1000000000000000000;
        num = num.toFixed(5);
        string = num.toString();
        return string;
      } catch (error) {
        console.error('Error convertAtomicToEgld:', error);
      }
    }
  }, {
    key: "getEnv",
    value: function getEnv() {
      try {
        if (typeof process.env.EGLD != 'undefined') {
          return JSON.parse(process.env.EGLD);
        } else {
          console.error('EGLD: Env variable not found');
          return {};
        }
      } catch (error) {
        console.error('Error env:', error);
      }
    }
  }, {
    key: "setupNetwork",
    value: function () {
      var _setupNetwork = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
        var _this_self$options, this_self, _t13;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.p = _context11.n) {
            case 0:
              _context11.p = 0;
              this_self = this;
              if ((_this_self$options = this_self.options) !== null && _this_self$options !== void 0 && _this_self$options.base_url) {
                _context11.n = 2;
                break;
              }
              _context11.n = 1;
              return this_self.sendFetchEnvTransaction(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(res) {
                  return _regenerator().w(function (_context10) {
                    while (1) switch (_context10.n) {
                      case 0:
                        if (!(_typeof(res) == 'object' && Object.keys(res).length > 0)) {
                          _context10.n = 1;
                          break;
                        }
                        this_self.options.base_url = res.base_url;
                        this_self.options.explorer_url = res.explorer_url;
                        this_self.options.network_provider_url = res.network_provider_url;
                        _context10.n = 1;
                        return this_self.initiateNetwork();
                      case 1:
                        return _context10.a(2);
                    }
                  }, _callee10);
                }));
                return function (_x5) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 1:
              _context11.n = 3;
              break;
            case 2:
              _context11.n = 3;
              return this_self.initiateNetwork();
            case 3:
              _context11.n = 5;
              break;
            case 4:
              _context11.p = 4;
              _t13 = _context11.v;
              console.error(_t13);
            case 5:
              return _context11.a(2);
          }
        }, _callee11, this, [[0, 4]]);
      }));
      function setupNetwork() {
        return _setupNetwork.apply(this, arguments);
      }
      return setupNetwork;
    }()
  }, {
    key: "initiateNetwork",
    value: function () {
      var _initiateNetwork = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12() {
        var _t14;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.p = _context12.n) {
            case 0:
              _context12.p = 0;
              if (!(this.apiNetworkProvider == null)) {
                _context12.n = 2;
                break;
              }
              // console.log("initiateNetwork: ////");

              this.apiNetworkProvider = new ApiNetworkProvider(this.options.base_url, {
                clientName: 'multiversx-your-client-name'
              });
              this.proxyNetworkProvider = new ProxyNetworkProvider(this.options.network_provider_url, {
                clientName: 'multiversx-your-client-name'
              });
              _context12.n = 1;
              return this.apiNetworkProvider.getNetworkConfig();
            case 1:
              this.networkConfig = _context12.v;
            case 2:
              _context12.n = 4;
              break;
            case 3:
              _context12.p = 3;
              _t14 = _context12.v;
              console.error(_t14);
            case 4:
              return _context12.a(2);
          }
        }, _callee12, this, [[0, 3]]);
      }));
      function initiateNetwork() {
        return _initiateNetwork.apply(this, arguments);
      }
      return initiateNetwork;
    }()
  }, {
    key: "returnServices",
    value: function returnServices() {
      try {
        var services = [];
        if (this.app.BROWSER == 0) {
          services.push(new PeerService(null, 'egld'));
        }
        return services;
      } catch (error) {
        console.error('Error returnServices:', error);
      }
    }
  }, {
    key: "onPeerServiceUp",
    value: function () {
      var _onPeerServiceUp = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(app, peer) {
        var service,
          _args13 = arguments,
          _t15;
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.p = _context13.n) {
            case 0:
              service = _args13.length > 2 && _args13[2] !== undefined ? _args13[2] : {};
              _context13.p = 1;
              if (app.BROWSER) {
                _context13.n = 2;
                break;
              }
              return _context13.a(2);
            case 2:
              if (!(service.service == 'egld')) {
                _context13.n = 3;
                break;
              }
              _context13.n = 3;
              return this.setupNetwork();
            case 3:
              _context13.n = 5;
              break;
            case 4:
              _context13.p = 4;
              _t15 = _context13.v;
              console.error('Error onPeerServiceUp:', _t15);
            case 5:
              return _context13.a(2);
          }
        }, _callee13, this, [[1, 4]]);
      }));
      function onPeerServiceUp(_x6, _x7) {
        return _onPeerServiceUp.apply(this, arguments);
      }
      return onPeerServiceUp;
    }()
  }, {
    key: "handlePeerTransaction",
    value: function () {
      var _handlePeerTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14(app) {
        var tx,
          peer,
          mycallback,
          message,
          _args14 = arguments,
          _t16;
        return _regenerator().w(function (_context14) {
          while (1) switch (_context14.p = _context14.n) {
            case 0:
              tx = _args14.length > 1 && _args14[1] !== undefined ? _args14[1] : null;
              peer = _args14.length > 2 ? _args14[2] : undefined;
              mycallback = _args14.length > 3 ? _args14[3] : undefined;
              _context14.p = 1;
              if (!(tx == null)) {
                _context14.n = 2;
                break;
              }
              return _context14.a(2, 0);
            case 2:
              message = tx.returnMessage(); //
              // we receive requests to create accounts here
              //
              if (!(message.request === 'egld fetch env')) {
                _context14.n = 3;
                break;
              }
              _context14.n = 3;
              return this.receiveFetchEnvTransaction(app, tx, peer, mycallback);
            case 3:
              return _context14.a(2, _superPropGet(EGLDModule, "handlePeerTransaction", this, 3)([app, tx, peer, mycallback]));
            case 4:
              _context14.p = 4;
              _t16 = _context14.v;
              console.error('Error handlePeerTransaction:', _t16);
            case 5:
              return _context14.a(2);
          }
        }, _callee14, this, [[1, 4]]);
      }));
      function handlePeerTransaction(_x8) {
        return _handlePeerTransaction.apply(this, arguments);
      }
      return handlePeerTransaction;
    }()
  }, {
    key: "sendFetchEnvTransaction",
    value: function () {
      var _sendFetchEnvTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15() {
        var callback,
          this_self,
          peers,
          data,
          _args15 = arguments,
          _t17;
        return _regenerator().w(function (_context15) {
          while (1) switch (_context15.p = _context15.n) {
            case 0:
              callback = _args15.length > 0 && _args15[0] !== undefined ? _args15[0] : null;
              _context15.p = 1;
              this_self = this;
              _context15.n = 2;
              return this.app.network.getPeers();
            case 2:
              peers = _context15.v;
              if (!(peers.length == 0)) {
                _context15.n = 3;
                break;
              }
              console.warn('No peers');
              return _context15.a(2);
            case 3:
              data = {};
              this_self.app.network.sendRequestAsTransaction('egld fetch env', data, function (res) {
                // console.log("Callback for sendCreateAccountTransaction request: ", res);
                if (_typeof(res) == 'object' && Object.keys(res).length > 0) {
                  //console.log("response from env", res);
                }
                if (callback) {
                  return callback(res);
                }
              }, peers[0].publicKey);
              _context15.n = 5;
              break;
            case 4:
              _context15.p = 4;
              _t17 = _context15.v;
              console.error('Error sendFetchEnvTransaction:', _t17);
            case 5:
              return _context15.a(2);
          }
        }, _callee15, this, [[1, 4]]);
      }));
      function sendFetchEnvTransaction() {
        return _sendFetchEnvTransaction.apply(this, arguments);
      }
      return sendFetchEnvTransaction;
    }()
  }, {
    key: "receiveFetchEnvTransaction",
    value: function () {
      var _receiveFetchEnvTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16(app, tx, peer, callback) {
        var m, _t18;
        return _regenerator().w(function (_context16) {
          while (1) switch (_context16.p = _context16.n) {
            case 0:
              _context16.p = 0;
              if (!(app.BROWSER == 0)) {
                _context16.n = 2;
                break;
              }
              m = this.getEnv(); //console.log("m: ", m);
              if (m) {
                _context16.n = 1;
                break;
              }
              console.error('MIXIN ENV variable missing.');
              return _context16.a(2);
            case 1:
              return _context16.a(2, callback(m));
            case 2:
              _context16.n = 4;
              break;
            case 3:
              _context16.p = 3;
              _t18 = _context16.v;
              console.error('Error receiveFetchEnvTransaction:', _t18);
            case 4:
              return _context16.a(2);
          }
        }, _callee16, this, [[0, 3]]);
      }));
      function receiveFetchEnvTransaction(_x9, _x0, _x1, _x10) {
        return _receiveFetchEnvTransaction.apply(this, arguments);
      }
      return receiveFetchEnvTransaction;
    }()
  }, {
    key: "validateAddress",
    value: function validateAddress(address) {
      return Address.isValid(address);
    }
  }, {
    key: "respondTo",
    value: function respondTo() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var obj = arguments.length > 1 ? arguments[1] : undefined;
      try {
        if (type == 'crypto-logo') {
          if ((obj === null || obj === void 0 ? void 0 : obj.ticker) == this.ticker) {
            return {
              svg: "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n                            <!-- Generator: Adobe Illustrator 27.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n                            <svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n                                 viewBox=\"0 0 192 148\" style=\"enable-background:new 0 0 192 148;\" xml:space=\"preserve\">\n                            <style type=\"text/css\">\n                                .st0{fill:#23F7DD;}\n                            </style>\n                            <path class=\"st0\" d=\"M106.4,74L192,28L177.6,0.2L99.2,32.1c-2,0.8-4.3,0.8-6.3,0L14.5,0.2L0.1,28l85.6,46l-85.6,46l14.4,27.8\n                                l78.4-31.9c2-0.8,4.3-0.8,6.3,0l78.4,31.9l14.4-27.8L106.4,74z\"/>\n                            </svg>\n                        ",
              img: '/egld/img/logo.png'
            };
          }
        }
        return null;
      } catch (error) {
        console.error('Error respondTo:', error);
      }
    }
  }]);
}(CryptoModule);
module.exports = EGLDModule;